import HttpError from 'utils/errors/HttpError';
import { traefikRequest } from 'utils/request';
import throwCustomError from 'utils/throwCustomError';

export const getManagerInfo = async (managerId) => {
  try {
    const url = `api/dealer-manager/${managerId}`;
    const { status, data } = await traefikRequest.get(url).catch(throwCustomError);

    if (status !== 200) {
      throw new HttpError(`status ${status}`);
    }

    return data;
  } catch (err) {
    console.log(err);
  }
};
